// extracted by mini-css-extract-plugin
module.exports = {"tab_button":"tab_button--TabButton-Button-components__2pIqf","tabButton":"tab_button--TabButton-Button-components__2pIqf","active":"active--TabButton-Button-components__2Y6lr"};